import { Outlet } from "react-router-dom";

import { FilterRegistrationProvider } from "./filter-registration/filter-registration.context";
import './registration.scss';

export function Registration() {
  return (
    <div id="ShellRegistration" className="registration">
       <FilterRegistrationProvider>
        <Outlet />
      </FilterRegistrationProvider>
    </div>
  );
}

export default Registration;
